import React, { Fragment } from 'react';
import styled from 'styled-components';
import { getTranslatedString } from 'helpers/i18n';
import { media } from 'helpers/MediaHelper';

import SelectedBreakdown from './SelectedBreakdown';

import Spacer from '../Spacer';
import Row from 'components/ui/Row';
import Col from 'components/ui/Col';
import Link from '../Link';

const StyledTitle = styled.span`
  font-size: 18px;
  font-family: 'Circular-Bold';
`;

const StyledRow = styled(Row)`
  display: flex;
  align-items: center;

  ${media.mobile`
    align-items: flex-start;
    flex-direction: column;
  `};
`;

const StyledCol = styled(Col)`
  ${media.mobile`
    width: auto;
  `};
`;

const ReviewSelected = ({ handleBack, handleSelect, selected, reviewStateOptions, name }) => {
  return (
    <Fragment>
      <Spacer mb={1}>
        <StyledRow>
          <StyledCol span={18}>
            <StyledTitle>
              {getTranslatedString('landlordPortal.reviewSelected.header', {
                selections: getTranslatedString(`landlordPortal.reviewSelected.${name}`),
                total: selected.length,
              })}
            </StyledTitle>
            <p>{getTranslatedString(`landlordPortal.reviewSelected.subHeader.${name}`)}</p>
          </StyledCol>
          <StyledCol span={6}>
            <Link onClick={handleBack} type="button" fontSize={18}>
              {getTranslatedString('landlordPortal.reviewSelected.add', {
                selections: getTranslatedString(`landlordPortal.reviewSelected.${name}`),
              })}
            </Link>
          </StyledCol>
        </StyledRow>
      </Spacer>
      <SelectedBreakdown
        breakdown={reviewStateOptions}
        selected={selected}
        handleSelect={handleSelect}
        name={name}
      />
    </Fragment>
  );
};

export default ReviewSelected;
